import React from 'react';
import ErrorPage from '../../../../../../../common/src/components/ErrorPage';
import CompanyScanAppShell from './CompanyScanAppShell';

const CompanyScanError: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <CompanyScanAppShell>
      <ErrorPage />
    </CompanyScanAppShell>
  );
};

export default CompanyScanError;
